export default {
  getApplications(state) {
    return state.applications
  },
  getStatuses(state) {
    return state.statuses
  },
  getAcceptors(state) {
    return state.acceptors
  },
  getCreateOrdersUsers(state) {
    return state.createOrdersUsers
  },
  getPurchasingPlan(state) {
    return state.purchasingPlan
  },
  getPersonalTimeZone(state) {
    return state.personalTimeZone
  },
  getStateLoading(state) {
    return state.stateLoading
  }
}